import React from "react";
import CartaDigital from "./components/CartaDigital";

function App() {
  return <CartaDigital />;
}

export default App;